import { Directive, ElementRef, HostListener } from "@angular/core";
import {
  AbstractControl,
  ValidationErrors,
  NG_VALIDATORS,
  Validator,
} from "@angular/forms";

@Directive({
  selector: "[cpfCnpjValidator]",
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: CpfCnpjValidatorDirective,
      multi: true,
    },
  ],
})
export class CpfCnpjValidatorDirective implements Validator {
  constructor(private el: ElementRef) {}

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }

  @HostListener("input", ["$event"])
  onInput(event: any): void {
    this.formatInput(event.target);
  }

  @HostListener("paste", ["$event"])
  onPaste(event: any): void {
    setTimeout(() => {
      this.formatInput(event.target);
    }, 0);
  }

  private formatInput(inputElement: any): void {
    let value = inputElement.value;
    value = value.replace(/\D/g, "");
    if (value.length > 14) {
      value = value.slice(0, 14);
    }

    if (value.length <= 11) {
      value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else if (value.length > 11) {
      value = value.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    }

    inputElement.value = value;
    inputElement.dispatchEvent(new Event("input"));
  }
}
